export default __webpack_public_path__ + "assets/models/eb1a2667aa9fab7bb4a927534ac8e662.gltf";